<div class="container-dialog">
  <h1 mat-dialog-title>{{ data?.title }}</h1>
  <div mat-dialog-content [innerHTML]="data?.html"></div>
  <div mat-dialog-actions>
    <button class="btn-close" mat-button mat-dialog-close>Fechar</button>
  </div>
</div>